// ** Redux Imports
import { createSlice } from '@reduxjs/toolkit'

// ** UseJWT import to get config
import useJwt from '@src/auth/jwt/useJwt'


const config = useJwt.jwtConfig


const initialUser = () => {

  const item = window.localStorage.getItem('userData')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : {}
}
// useEffect(() => {
//   document.documentElement.style.setProperty("--Colorcompany-id", action.payload.data.companyID)
// }, [action.payload.data.companyID])
export const authSlice = createSlice({
  name: 'authentication',
  initialState: {
    userData: initialUser()
  },
  reducers: {
    handleLogin: (state, action) => {
          
      //localStorage.removeItem(config.storageRefreshTokenKeyName)
      // window.location.reload()
        
      window.localStorage.clear()
      window.sessionStorage.clear()
      state.userData = action.payload.data
      state[config.storageTokenKeyName] = action.payload.data.token
         
      //state[config.storageRefreshTokenKeyName] = action.payload[config.storageRefreshTokenKeyName]
      localStorage.setItem('CompanyIdentifier', JSON.stringify(action.payload.data.companyIdentifier))
      localStorage.setItem('ClientParentEntryUserID', JSON.stringify(action.payload.data.parentEntryUserID))
      localStorage.setItem('userData', JSON.stringify(action.payload.data))
      localStorage.setItem('fullName', JSON.stringify(action.payload.data.fullName))
      localStorage.setItem('staffRoleID', JSON.stringify(action.payload.data.staffRoleID))
      localStorage.setItem('userID', JSON.stringify(action.payload.data.userID))
      localStorage.setItem('companyID', JSON.stringify(action.payload.data.companyID))
      localStorage.setItem('fileDescription', action.payload.fileDescription)
     
      localStorage.setItem('isClientParent', JSON.stringify(action.payload.data.isParent))
      localStorage.setItem('ClientParentID', JSON.stringify(action.payload.data.parentCLientID))
      // document.documentElement.style.setProperty('--use-variables', '0') // Disables variables
      // document.documentElement.style.setProperty('--use-variables', '1') // Enables variables

      localStorage.setItem('companyDateFormat', JSON.stringify('d-m-Y'))
      localStorage.setItem(config.storageTokenKeyName, JSON.stringify(action.payload.data.token))
      localStorage.setItem('userToken', JSON.stringify(action.payload.data.token))
      localStorage.setItem('userUniqueID', JSON.stringify(action.payload.data.uniqueTypeID))
      localStorage.setItem('UserIDDecode', JSON.stringify(action.payload.data.userIDDecode))
      localStorage.setItem('vatAmount', JSON.stringify(action.payload.data.vatPercentage))
      localStorage.setItem('vatPercentage', JSON.stringify(action.payload.data.vatPercentage / 100))
      localStorage.setItem('isCompanyVatRegistered', JSON.stringify(action.payload.data.isCompanyVatRegistered))
      
      localStorage.setItem('IsFlag', JSON.stringify(true))
      // localStorage.setItem('passwordDate', JSON.stringify(action.payload.data.passwordChangingDate))
      const headers = {
        token: JSON.parse(localStorage.getItem('userToken')),
        userID: JSON.parse(localStorage.getItem('userID'))
      }
      window.localStorage.setItem("Headers", JSON.stringify(headers))
      window.localStorage.setItem("passwordDate", JSON.stringify(action.payload.data.passwordChangingDate))
      // localStorage.setItem(config.storageRefreshTokenKeyName, JSON.stringify(action.payload.refreshToken))
    },
    handleLogout: state => {
      if ((JSON.parse(localStorage.getItem('companyID')) === 10005 || JSON.parse(localStorage.getItem('companyID')) === 10006) && JSON.parse(localStorage.getItem('staffRoleID')) === "Passenger") {
         
       window.location.href = '/login?CharChauf_PassApp'
       state.userData = {}
      state[config.storageTokenKeyName] = null
      // state[config.storageRefreshTokenKeyName] = null
      // ** Remove user, accessToken & refreshToken from localStorage
      localStorage.removeItem('userData')
      localStorage.removeItem('fullName')
      localStorage.removeItem('staffRoleID')
      localStorage.removeItem('userID')
      localStorage.removeItem('userToken')
      localStorage.removeItem('userUniqueID')
      localStorage.removeItem('passwordDate')
      } else if (JSON.parse(localStorage.getItem('companyID')) === 10010 && JSON.parse(localStorage.getItem('staffRoleID')) === "Passenger") {
         
        window.location.href = '/login?DE_PassApp'
        state.userData = {}
       state[config.storageTokenKeyName] = null
       // state[config.storageRefreshTokenKeyName] = null
       // ** Remove user, accessToken & refreshToken from localStorage
       localStorage.removeItem('userData')
       localStorage.removeItem('fullName')
       localStorage.removeItem('staffRoleID')
       localStorage.removeItem('userID')
       localStorage.removeItem('userToken')
       localStorage.removeItem('userUniqueID')
       localStorage.removeItem('passwordDate')
       } else if ((JSON.parse(localStorage.getItem('companyID')) === 1) && JSON.parse(localStorage.getItem('staffRoleID')) === "Passenger") {
         
        window.location.href = '/login?UKCB_PassApp'
        state.userData = {}
       state[config.storageTokenKeyName] = null
       // state[config.storageRefreshTokenKeyName] = null
       // ** Remove user, accessToken & refreshToken from localStorage
       localStorage.removeItem('userData')
       localStorage.removeItem('fullName')
       localStorage.removeItem('staffRoleID')
       localStorage.removeItem('userID')
       localStorage.removeItem('userToken')
       localStorage.removeItem('userUniqueID')
       localStorage.removeItem('passwordDate')
       } else if (JSON.parse(localStorage.getItem('companyID')) === 10005 || JSON.parse(localStorage.getItem('companyID')) === 10006) {
         
        window.location.href = '/login?CharChauf'
        state.userData = {}
       state[config.storageTokenKeyName] = null
       // state[config.storageRefreshTokenKeyName] = null
       // ** Remove user, accessToken & refreshToken from localStorage
       localStorage.removeItem('userData')
       localStorage.removeItem('fullName')
       localStorage.removeItem('staffRoleID')
       localStorage.removeItem('userID')
       localStorage.removeItem('userToken')
       localStorage.removeItem('userUniqueID')
       localStorage.removeItem('passwordDate')
       } else if (JSON.parse(localStorage.getItem('companyID')) === 10010) {
         
        window.location.href = '/login?DE'
        state.userData = {}
       state[config.storageTokenKeyName] = null
       // state[config.storageRefreshTokenKeyName] = null
       // ** Remove user, accessToken & refreshToken from localStorage
       localStorage.removeItem('userData')
       localStorage.removeItem('fullName')
       localStorage.removeItem('staffRoleID')
       localStorage.removeItem('userID')
       localStorage.removeItem('userToken')
       localStorage.removeItem('userUniqueID')
       localStorage.removeItem('passwordDate')
       } else if (JSON.parse(localStorage.getItem('companyID')) === 10011) {
         
        window.location.href = '/login?HP'
        state.userData = {}
       state[config.storageTokenKeyName] = null
       // state[config.storageRefreshTokenKeyName] = null
       // ** Remove user, accessToken & refreshToken from localStorage
       localStorage.removeItem('userData')
       localStorage.removeItem('fullName')
       localStorage.removeItem('staffRoleID')
       localStorage.removeItem('userID')
       localStorage.removeItem('userToken')
       localStorage.removeItem('userUniqueID')
       localStorage.removeItem('passwordDate')
       } else if (JSON.parse(localStorage.getItem('companyID')) === 1) {
         
        window.location.href = '/login?UKCB'
        state.userData = {}
       state[config.storageTokenKeyName] = null
       // state[config.storageRefreshTokenKeyName] = null
       // ** Remove user, accessToken & refreshToken from localStorage
       localStorage.removeItem('userData')
       localStorage.removeItem('fullName')
       localStorage.removeItem('staffRoleID')
       localStorage.removeItem('userID')
       localStorage.removeItem('userToken')
       localStorage.removeItem('userUniqueID')
       localStorage.removeItem('passwordDate')
       } else {
        state.userData = {}
        state[config.storageTokenKeyName] = null
        // state[config.storageRefreshTokenKeyName] = null
        // ** Remove user, accessToken & refreshToken from localStorage
        localStorage.removeItem('userData')
        localStorage.removeItem('fullName')
        localStorage.removeItem('staffRoleID')
        localStorage.removeItem('userID')
        localStorage.removeItem('userToken')
        localStorage.removeItem('userUniqueID')
        localStorage.removeItem('passwordDate')
        window.location.reload()
      }
    
      //localStorage.removeItem(config.storageRefreshTokenKeyName)
    }
  }
})

export const { handleLogin, handleLogout } = authSlice.actions

export default authSlice.reducer
